import React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';
import Icon from 'components/UI/Icon';

import * as styles from './featuresDesktop.module.scss';
import useIntersection from 'hooks/useIntersection';

const FeaturesDesktop = ({ data }) => {
  const { scrollWrapper, inViewSec, inViewRefSec } = useIntersection({
    threshold: 0.3,
  });

  return (
    <section className={classnames(styles.section)} ref={scrollWrapper}>
      <div className={'cr-wrap'}>
        <div
          className={classnames(styles.inner, {
            [styles.jsAnimInit]: inViewSec,
          })}
        >
          <div className={classnames(styles.head)} ref={inViewRefSec}>
            <p
              className={classnames(styles.subtitle, 'cr-subheader cr-text-3')}
            >
              {data.subtitle}
            </p>
            <h2 className={classnames(styles.title, 'cr-h2')}>{data.title}</h2>
            <div className={classnames(styles.links)}>
              {data.links.map((link, i) => (
                <Link
                  key={i}
                  to={link.featuresLinkSrc.uri}
                  className={classnames(
                    link.class,
                    'cr-btn cr-btn--icon cr-btn--icon-arrow cr-btn--wide cr-btn--large',
                    { 'cr-btn--icon-red-bg': i % 2 === 0 }
                  )}
                >
                  {link.featuresLinkText}
                  <Icon name="corner-arrow-small-bold" />
                </Link>
              ))}
            </div>
          </div>
          <ul className={classnames(styles.list)}>
            {data.list.map((item, i) => (
              <li key={i}>
                {/* TODO: вынести в отдельный компонент */}
                <Link
                  to={item.featuresListLink.uri}
                  className={classnames(styles.item)}
                >
                  <p className={classnames(styles.iconsWrap)}>
                    <i>
                      <img src={item.featuresListIcon?.sourceUrl} alt="" />
                    </i>
                    <i className={classnames(styles.iconsWrap_arrow)}>
                      <Icon name={'corner-arrow-small-bold'} />
                    </i>
                  </p>

                  <h3 className={classnames(styles.item_title, 'cr-h3')}>
                    {item.featuresListTitle}
                  </h3>

                  <p className={classnames(styles.description)}>
                    {item.featuresListDescription}
                  </p>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default FeaturesDesktop;
